
const IGNORED_PAGE_PATHS = [
    // Root
    (pathname: string) => /^\/$/i.test(pathname)
];

export default IGNORED_PAGE_PATHS;